<template>
    <div class="box_back">
        <div class="forContainer">

                    <h3>网页管理后台</h3>
                    <el-form ref="loginFormRef" :model="loginForm" status-icon :rules="loginRules" label-width="80px"
                        class="loginform">
                        <el-form-item label="账户" prop="username">
                            <el-input v-model="loginForm.username" autocomplete="off" />
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input v-model="loginForm.password" type="password" autocomplete="off" />
                        </el-form-item>

                        <div
                            style="display: flex; flex-direction: column; align-items: center; margin-left: -15%; margin-top: -0%;">
                            <el-form-item>
                                <el-button type="primary" @click="submitForm()">登录</el-button>
                            </el-form-item>
                        </div>

                    </el-form>
        </div>
        <!-- <div style="margin-top: 90%; color: aliceblue; position: fixed; bottom: 0; left: 0; right: 0; text-align: center;">
            <a href="https://beian.miit.gov.cn/" target="_blank" style="color: aliceblue;font-size: 10px;">ICP备案号  ————  </a>
            <a href="https://beian.miit.gov.cn/" target="_blank" style="color: aliceblue;font-size: 10px;">  浙ICP备2024104231号</a>
        </div> -->
    </div>
</template>

<script setup>
import { Button } from 'element-plus';
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex';

// import 'element-plus/lib/theme-chalk/index.css';

const store = useStore()
const loginForm = reactive({
    username: "",
    password: "",
})//表单绑定的响应对象

const loginFormRef = ref() //表单的引用对象

//校验规则
const loginRules = reactive({
    username: [{ required: true, message: "请输入用户名", trigger: 'blur' }],
    password: [{ required: true, message: "请输入密码", trigger: 'blur' }],
})

const router = useRouter();

const submitForm = () => {
    loginFormRef.value.validate((valid) => {
        // console.log(valid);
        if (valid) {
            axios.post("/adminapi/admin/login", loginForm).then(res => {
                // console.log(res.data);
                if (res.data.ActionType === 'OK') {
                    // 换账号登录时先清掉上一个身份的缓存，避免旧 role 影响路由准入判断
                    store.commit("clearUserInfo")
                    store.commit("changeUserInfo", res.data.data)
                    store.commit("changeGetterRouter", false)
                    router.push("/admin/index")
                } else {
                    ElMessage.error('密码错误')
                }
            })
        }
    })
}

</script>

<style lang="scss" scoped>
.box_back {
    width: 100%;
    height: 100%;
    background-image: url(../image/back1.jpg);
    background-size: cover;
    background-position: top left;
    background-repeat: no-repeat;
    position: fixed;
}

.forContainer {
    width: 500px;
    height: 280px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(0, 0, 0, 0.7);
    text-align: center;
    color: rgb(255, 255, 255);
    padding: 20px;
    border-radius: 10px;

    h3 {
        margin-top: 20px;
        font-size: 30px;
    }

    .loginform {
        margin-top: 40px;
    }
}

::v-deep.el-form-item label {
    color: white;
}
</style>